import useCurrencyCode from '~/client/hooks/currency/useCurrencyCode';
import useCurrentUser from '~/client/hooks/user/useCurrentUser';
import useNotificationsContext from '~/client/shared/NotificationContext/useNotificationsContext';
import useOtherFreebetRewardNotification from '../OtherFreebetRewardNotification/useOtherFreebetRewardNotification';

type Args = {
  rewardCurrency?: Unit;
  inGameCurrency?: Unit;
  walletCurrency?: Unit;
};

const useIngameCurrencyRules = ({
  rewardCurrency,
  inGameCurrency,
  walletCurrency,
}: Args = {}) => {
  const { notifications } = useNotificationsContext();

  const hasRequiredSwitchNotification = notifications.some(
    (notif) => notif.customId === 'freebetRewardSwitch' && !notif.dismissable,
  );

  const activeCurrency = useCurrencyCode();
  const { profile } = useCurrentUser();
  const profileIGC = profile?.settings?.preferredInGameCurrency as Unit;
  const IGC = inGameCurrency || profileIGC;

  const { reward } = useOtherFreebetRewardNotification({
    inGameCurrency: IGC,
    walletCurrency,
  });

  const invalidCurrencyPairs =
    (walletCurrency || activeCurrency) !== IGC &&
    IGC === (rewardCurrency || reward?.currency);

  return {
    isRequiredSwitch: invalidCurrencyPairs || hasRequiredSwitchNotification,
    isGameLoadingDisabled: hasRequiredSwitchNotification,
  };
};

export default useIngameCurrencyRules;
